import * as types from '../actions/actionTypes';

const initialState = {
  showAdvancedQuoting: false,
  activeQuoteIndex: 0,
  advancedQuotingSearchItem: null, // is needed for materials page (item that was clicked to change)
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.TOGGLE_SHOW_ADVANCED_QUOTING:
    case types.SET_ADVANCED_QUOTING_SEARCH_ITEM:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
